import Vue from 'vue'
import VueRouter from 'vue-router'
// ルート用のコンポーネントを読み込む
import Home from '@/views/Home'
import skill from '@/views/Skill'
import work from '@/views/Work'
import Contact from '@/views/Contact'
// Vuexと同様で最初にプラグインとして登録
Vue.use(VueRouter)
// VueRouterインスタンスを生成する
const router = new VueRouter({
  mode:'history',
  // URLのパスと紐づくコンポーネントをマッピング
  routes: [
    {
      path: '',
      component: Home
    },
    {
      path: '/home',
      component: Home
    },
    {
      path: '/skill',
      component: skill
    },
    {
      path: '/work',
      component: work
    },
    {
      path: '/contact',
      component: Contact
    }
  ]
})
// 生成したVueRouterインスタンスをエクスポート
export default router


// WEBPACK FOOTER //
// ./src/router.js